import type Punch from '@/data/punch/model';
import type { DataResponse, QueryString } from '@/data/types';
import V3 from '@/shared/api/v3';
import { parseAPIError } from '@/shared/redux/helpers/parseApiError';
import { createWiwAsyncThunk } from '@/store';

type FetchPunchRequest = {
  startTime: string;
  endTime?: string;
  userId?: number;
  params?: QueryString;
};

export const fetchPunches = createWiwAsyncThunk<DataResponse<Punch[]>, FetchPunchRequest>(
  'punch/fetch',
  async ({ startTime, endTime, userId, params = {} }, { rejectWithValue }) => {
    params = { startTime, endTime, userId, ...params };
    try {
      return await V3.url('/punches').query(params).get();
    } catch (error) {
      return rejectWithValue(parseAPIError(error));
    }
  },
);
